export interface PendoVisitor {
  id: string
  role: string
  organizationName: string
  organizationNumber: string
  loggedIn: boolean
  locale: string
  grades: string[]
  readOnlyGrades: string[]
  subjects: string[]
  trialOnly?: boolean // Should only be set when we actually know the value, not initialized as e.g. false
}

export interface PendoAccount {
  id: string
  organizationName: string
  organizationNumber: string
  trialOnly?: boolean
}

export interface PendoUser {
  visitor: PendoVisitor
  account: PendoAccount
  events?: PendoEvents
}

export interface PendoEvents {
  ready: () => void
}

export interface PendoSearchData {
  text: string
  subjects: string
  grades: string
  labels: string
  results: number
}

export interface PendoLoginButtonTrack {
  type: string
}

export type PendoTrackData = PendoSearchData | PendoLoginButtonTrack

export enum PendoTrackName {
  SearchPage = 'SEARCH_PAGE',
  LoginButton = 'LOGIN_BUTTON',
}

export enum PendoEventName {
  Ready = 'pendo:ready',
}
